export const selectLinkPopup = async (editor, selectOpts, callBackAfterCreatingPopup) => {
  const selectLinkDiv = document.querySelector("#select-link");
  if (selectLinkDiv.classList.contains("d-none")) {
    selectLinkDiv.classList = "";
    selectLinkDiv.innerHTML = "";
  }

  const modal = `<div class="fade modal show" role="dialog" aria-modal="true" style="display: block;">
    <div style="padding-right: 17px;" class="modal-dialog modal-dialog-centered modal-sm">
      <div class="modal-content">
        <div class="modal-header">
          <div class="modal-title h5">Select Type of Link</div>&nbsp;
          <button class="btn-close" aria-label="close"></button>
        </div>
        <div class="modal-body">
          <div id="select-link-container">
            <div class="row">
              <div class="col" style="border-right: 1px solid #ccc;">
                <form>
                  <div class="form-group mb-3">
                    <label for="select-link-type">Select Link Type</label>
                    <select id="select-link-type" name="select-link-type" class="form-control">
                      <option hidden>Select</option>
                      ${selectOpts
                        .map(
                          (selectOpt) => `<option>${selectOpt.name}</option>`
                        )
                        .join("")}
                    </select>
                  </div>
                  <div class="form-group">
                    <button id="submit-link-type" class="btn btn-primary w-100" disabled>Create Component</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="fade modal-backdrop show"></div>`;

  selectLinkDiv.innerHTML = modal;

  const closeBtn = document.querySelector("#select-link .btn-close");

  const selectInput = document.querySelector("#select-link-type");
  const submitButton = document.querySelector("#submit-link-type");

  selectInput.addEventListener("change", (e) => {
    const selectTypeValue = e.target.value;
    submitButton.removeAttribute("disabled");
    submitButton.innerHTML = `Create ${selectTypeValue}`;
  });

  submitButton.addEventListener("click", (e) => {
    e.preventDefault();
    const selectedType = selectInput.value;
    selectLinkDiv.className = "d-none";
    callBackAfterCreatingPopup(selectedType);
  });

  closeBtn.addEventListener("click", () => {
    selectLinkDiv.className = "d-none";
    callBackAfterCreatingPopup();
  });
};
